const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

const FOLDER_BY_MEDIA_TYPE = {
    adsImage: 'image',
    adsGif: 'gif',
    adsVideos: 'video',
};

/** Proxy URL so browser video/img tags load via API (no JWT on media tags). */
export function getAdsMediaDisplayUrl(fullUrl, mediaType = 'adsVideos', adId = null) {
    if (!fullUrl) return '';
    const folder = FOLDER_BY_MEDIA_TYPE[mediaType] || 'video';
    const filename = fullUrl.split('?')[0].split('/').pop() || '';
    if (!filename) return fullUrl;

    if (adId) {
        return `${API_BASE}/api/ads/${adId}/media/${folder}/${encodeURIComponent(filename)}`;
    }
    return `${API_BASE}/api/ads/media/serve/${folder}/${encodeURIComponent(filename)}`;
}

/** Resolve video src: try API proxy first; caller can fall back to stored R2 URL on error. */
export function getAdsVideoSrc(fullUrl, adId = null, useDirect = false) {
    if (!fullUrl) return '';
    if (useDirect) return fullUrl;
    return getAdsMediaDisplayUrl(fullUrl, 'adsVideos', adId);
}
